module.exports = __webpack_public_path__ + "img/logo_3_black.5eededc4.svg";